/* eslint semi: 1 */

import { isUndefined } from 'lodash';

export default {
  data () {
    return {
      onEnterMixinBound: false,
      onEnterEventHandlerMixin: undefined
    };
  },
  /**
   * Add onEnter global event handler on component mount
   */
  mounted () {
    if (this.$props?.isActive && isUndefined(this.$props.isActive)) {
      console.warn('To use onEnter mixin you must define isActive property');
      return;
    }
    if (!this.onEnter) {
      console.warn('There is no onEnter function defined inside your component');
      return;
    }
    this.$data.onEnterEventHandlerMixin = this.onEnterMixin.bind(this);
    this.toggleEnterPressListener(this.$props?.isActive ?? false);
  },
  watch: {
    isActive: {
      immediate: true,
      handler (newVal, oldVal) {
        // register only for changes
        if (newVal !== oldVal) {
          if (!newVal) {
            this.toggleEnterPressListener(false);
          } else {
            this.toggleEnterPressListener(true);
          }
        }
      }
    }
  },
  methods: {
    /**
     * checks for Enter keydown event and triggers onEnter function downstream
     */
    onEnterMixin (event) {
      if (event.key === 'Enter' && event.keyCode === 13) {
        this.onEnter(event);
        event.preventDefault();
      }
    },
    /**
     * Add global listener for Enter keydown and manages
     * it's presence depends on isActive property state of the main component
     */
    toggleEnterPressListener (switchState) {
      // if mixin improperly initialized, or not mounted YET
      if (!this.$data.onEnterEventHandlerMixin) {
        return;
      } else if (this.$data.onEnterMixinBound && switchState) {
        // make this method idempotent
        return;
      }

      // flip listener based off switchState argument
      if (switchState) {
        document.addEventListener('keydown', this.$data.onEnterEventHandlerMixin);
        // global flag to make idempotent call to toggleEnterPressListener
        this.$data.onEnterMixinBound = true;
      } else {
        this.$data.onEnterMixinBound = false;
        document.removeEventListener('keydown', this.$data.onEnterEventHandlerMixin);
      }
    }
  }
};
